import { createSlice } from '@reduxjs/toolkit';

import { PromotionState } from 'types/promotion';
import { INITIAL_LIST_PARAMS } from 'config';

const initialState: PromotionState = {
  isLoading: false,
  promotionList: {},
  promotionListParams: INITIAL_LIST_PARAMS,
  filtersListParams: INITIAL_LIST_PARAMS,
};

const slice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getPromotionList(state, action) {
      state.isLoading = false;
      state.promotionList = action.payload;
    },

    getPromotion(state, action) {
      state.isLoading = false;
      state.promotion = action.payload;
    },

    setPromotionListParams(state, action) {
      state.promotionListParams = action.payload;
    },

    setFiltersListParams(state, action) {
      state.filtersListParams = action.payload;
    },

    clearPromotion(state) {
      state.promotion = undefined;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getPromotionList,
  setPromotionListParams,
  getPromotion,
  setFiltersListParams,
  clearPromotion,
} = slice.actions;
